module.exports = __webpack_public_path__ + "img/1-1.65c003e0.png";